import React, {useState, useRef, useEffect} from 'react';
import clsx from 'clsx';

export default function FaqItem({faq = {}, question, answer, ...props}) {
  question ||= faq.question;
  answer ||= faq.answer;

  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    }
  }, [isOpen]);

  return (
    <div className="border-b border-gray-200 mb-2 ">
      <FaqItemQuestion
        isOpen={isOpen}
        question={question}
        onClick={() => setIsOpen(prev => !prev)}
      />

      <div
        className="overflow-hidden transition-all duration-300 ease-in-out"
        style={{
          maxHeight: isOpen ? `${height}px` : "0px",
          opacity: isOpen ? 1 : 0,
        }}
      >
        <div ref={contentRef} className="">
          <FaqItemAnswer answer={answer} isOpen={isOpen}/>
        </div>
      </div>
    </div>
  );
}


function FaqItemQuestion({question, onClick, isOpen = false}) {
  return (
    <div
      onClick={onClick}
      className="flex items-center justify-between cursor-pointer py-2"
    >
      <h3 className="text-lg font-bold">
        {question}
      </h3>

      <i
        className={clsx(
          "fa-solid fa-chevron-down transition-all duration-300",
          isOpen ? "rotate-180 text-blue-600" : "text-gray-400"
        )}
      />
    </div>
  );
}

function FaqItemAnswer({answer, isOpen = false}) {
  return (
    <div className="pb-2"
      dangerouslySetInnerHTML={{__html: answer}}
    />
  );
}
